import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { SOY } from 'reservations/brand/constants';

const AvailabilitiesErrorContainer = ({ message }: { message: string }) => (
  <Box sx={{ p: '16px' }}>
    <Typography
      sx={{
        color: SOY,
        fontSize: '16px',
        fontWeight: 450,
        textAlign: 'center'
      }}
      data-testid="availabilities-error-container"
    >
      {message}
    </Typography>
  </Box>
);

export default AvailabilitiesErrorContainer;
